import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen
    
    if (this.isOpen) {
      this.menuTarget.classList.remove("hidden")
      this.menuTarget.classList.add("block")
      document.body.classList.add("overflow-hidden")
    } else {
      this.menuTarget.classList.remove("block")
      this.menuTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  close() {
    this.isOpen = false
    this.menuTarget.classList.remove("block")
    this.menuTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}